import Block from './Block'
import TweenMax from 'gsap/TweenMaxBase'
import App from '../App'

export default class Accordion extends Block {
  constructor(el, destroyLast) {
    super(el, destroyLast)

    this.height = 0
    this.menuOpen = false
    this.isAnimating = false
    this.active = null
  }

  bindMethods() {
    super.bindMethods()
    this.toggle = this.toggle.bind(this)
  }

  getElems() {
    super.getElems()
    this.dropdown = this.el.querySelectorAll('.title')
    this.dropDownContainer = this.el.querySelectorAll('.accordion__dropdown')
  }

  events() {
    super.events()
    for (let i = 0; i < this.dropdown.length; i++) {
      this.dropdown[i].addEventListener('click', this.toggle.bind(this, i))
    }
  }

  toggle(index) {
    if (this.isAnimating) return

    if (this.dropdownOpen) this.close(index)
    else this.open(index)
  }

  open(index) {
    return new Promise((resolve) => {
      if (this.dropdownOpen) return

      const dropdownContent = this.dropdown[index].parentNode.querySelector('.accordion__dropdown-content')
      const dropdownHeight = dropdownContent.children[0].offsetHeight

      this.dropdown[index].classList.add('is-opened')
      dropdownContent.classList.add('active')
      this.active = this.el.querySelector('.active')

      TweenMax.to(dropdownContent, 1, {
        height: dropdownHeight,
        ease: Power3.easeOut,
        onComplete: () => {
          App.smoothScroll && App.smoothScroll.update()
        }
      })

      this.oldIndex = index

      this.dropdownOpen = true
      resolve()
    })
  }

  close(index) {
    return new Promise((resolve) => {
      const dropdownContent = this.dropdown[index].parentNode.querySelector('.accordion__dropdown-content')

      TweenMax.to(this.active, 1, {
        height: 0,
        ease: Power3.easeOut,
        onComplete: () => {
          App.smoothScroll && App.smoothScroll.update()
        }
      })

      this.dropDownContainer[this.oldIndex].querySelector('.title').classList.remove('is-opened')
      this.active.classList.remove('active')

      this.dropdownOpen = false

      if (dropdownContent !== this.active) this.open(index)

      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Accordion.js